var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg91(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2466_1079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4688 32C45.4688 24.5732 39.4268 18.5312 32 18.5312C24.5732 18.5312 18.5312 24.5733 18.5312 32C18.5312 39.4266 24.5734 45.4687 32 45.4687C39.4266 45.4687 45.4688 39.4267 45.4688 32ZM32 39.5235C27.8515 39.5235 24.4765 36.1485 24.4765 32C24.4765 27.8515 27.8515 24.4765 32 24.4765C36.1485 24.4765 39.5235 27.8515 39.5235 32C39.5235 36.1485 36.1485 39.5235 32 39.5235Z",
    fill: "#E8202D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 35.7734C34.0841 35.7734 35.7736 34.084 35.7736 31.9999C35.7736 29.9159 34.0841 28.2264 32.0001 28.2264C29.916 28.2264 28.2266 29.9159 28.2266 31.9999C28.2266 34.084 29.916 35.7734 32.0001 35.7734Z",
    fill: "#E8202D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 32.0002C14.7812 24.1869 20.0126 17.5736 27.1564 15.4761C21.5398 16.4156 15.7125 18.9472 10.0555 22.9367C4.59662 26.7864 1.22512 30.6033 1.08425 30.7639L0 32.0002L1.08425 33.2366C1.22512 33.3972 4.5965 37.2139 10.0555 41.0638C15.7125 45.0533 21.5398 47.5848 27.1564 48.5244C20.0128 46.4268 14.7812 39.8134 14.7812 32.0002Z",
    fill: "#E8202D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9159 30.7637C62.775 30.6031 59.4036 26.7863 53.9446 22.9365C48.2876 18.947 42.4604 16.4155 36.8438 15.4758C43.9875 17.5733 49.2189 24.1867 49.2189 32C49.2189 39.8132 43.9875 46.4266 36.8438 48.5241C42.4604 47.5846 48.2876 45.053 53.9446 41.0635C59.4035 37.2137 62.775 33.3968 62.9159 33.2362L64.0001 31.9998L62.9159 30.7637Z",
    fill: "#E8202D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2466_1079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg91);
export default __webpack_public_path__ + "static/media/svg91.d1d51b0765dc017ef7473e5285e52134.svg";
export { ForwardRef as ReactComponent };